import * as yup from 'yup';

import generalSettingsSchema from './schemas/generalSettings';
import partnerSpecificSettingsSchema from './schemas/partnerSpecificSettings';
import botPromptTriggerSettingsSchema from './schemas/botPromptTriggerSettings';

const validators = {
  async validateBusinessData(data) {
    return new Promise(resolve => {
      const options = { strict: true, abortEarly: false };
      this._schema
        .validate(data, options)
        .then(() => {
          resolve([]);
        })
        .catch(e => {
          resolve(this._normalizeErrors(e));
        });
    });
  },

  _schema: yup.object().shape({
    generalSettings: generalSettingsSchema.noUnknown(false),
    partnerSpecificSettings: partnerSpecificSettingsSchema.noUnknown(false),
    botPromptTriggerSettings: botPromptTriggerSettingsSchema,
  }),

  _normalizeErrors: e => {
    return e.inner.map(validationError => {
      const page = validationError.path.split('.')[0];
      const key = validationError.path
        .split(`${page}.`)
        .slice(1)
        .join(`${page}.`);
      return {
        page,
        key,
        label: validationError.label,
        value: validationError.value,
        type: validationError.name,
        message: validationError.message,
        _meta: validationError,
      };
    });
  },
};

export default validators;
